import { render, staticRenderFns } from "./properties-component.vue?vue&type=template&id=5089ecfa&scoped=true"
import script from "./properties-component.vue?vue&type=script&lang=js"
export * from "./properties-component.vue?vue&type=script&lang=js"
import style0 from "./properties-component.vue?vue&type=style&index=0&id=5089ecfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089ecfa",
  null
  
)

export default component.exports